<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001522')">
              <local-tabButton :tabButtonList="statusList" @selectStatus="statusBtn"></local-tabButton>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--新增消息模板-->
      <Button class="mr15" type="primary" @click="$refs['messageTemplate'].initMessageTemplateData('add')"
        v-if="getPermission('ymsStationNotificationTemplate_insert')">{{ $t('key1002270') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        :loading="tableLoading"
        border
        max-height="600"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--新增、编辑消息模板弹窗-->
    <messageTemplateModal
      ref="messageTemplate"
      :supplierNoticeType="supplierNoticeType"
      :distributorNoticeType="distributorNoticeType"
      @updateData="pageParamsStatus = true">
    </messageTemplateModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import messageTemplateModal from "@/views/yms/components/basicSettings/messageTemplateModal.vue";
import {INFORMATIONTYPELIST} from "@/utils/enum";
import {_handleMultilingualFields} from "@/utils/common";

export default {
  name: "messageNotification",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        status: null,
      },
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002262'),
          key: 'name',
          align: 'center',
          render(h, params) {
            let name = _handleMultilingualFields(params.row.title);
            return h('div', name);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002263'),
          key: 'informationType',
          align: 'center',
          render(h, params) {
            let status = params.row.informationType;
            let text = '';
            v.informationTypeList.map((item) => {
              if (item.value === status) {
                text = item.name;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002264'),
          key: 'notice',
          align: 'center',
          render(h, params) {
            let text = '';
            let status = params.row.informationType;
            if (v.distributorNoticeType.includes(status)) {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000015');
            } else if (v.supplierNoticeType.includes(status)) {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000014');
            } else {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000013');
            }
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002265'), // '接收类型 1:站内信 2:邮件 3:短信 例如 ['1','2>3']' ,
          key: 'receiveMode',
          align: 'center',
          render(h, params) {
            let arr = [];
            let text = '';
            let receiveMode = params.row.receiveModeList || [];
            let receiveModeList = [
              {value: '1', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002266')},
              {value: '2>3', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002267')},
              {value: '3>2', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002268')}
            ];
            receiveModeList.map((item) => {
              receiveMode.map((ele) => {
                if (ele === item.value) {
                  arr.push(item.name);
                }
              });
            });
            if (arr.length > 0) {
              text = arr.join('、');
            }
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          align: 'center',
          render(h, params) {
            let status = params.row.status;
            let text = '';
            v.statusList.map((item) => {
              if (item.value === status) {
                text = item.title;
              }
            });
            return h('span', {
              class: status === 1 ? 'openStatus' : 'stopStatus'
            }, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 170,
          render: (h, params) => {
            let ymsStationNotificationTemplateId = params.row.ymsStationNotificationTemplateId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsStationNotificationTemplate_update'),
                    clickFn: () => {
                      v.$refs['messageTemplate'].initMessageTemplateData('edit', ymsStationNotificationTemplateId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    color: '#FF0000',
                    show: v.getPermission('ymsStationNotificationTemplate_delete'),
                    clickFn: () => {
                      v.deleteMessageTemplateBtn(ymsStationNotificationTemplateId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      statusList: [
        {selected: true, value: null, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {selected: false, value: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')},
        {selected: false, value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')}
      ],
      distributorNoticeType: [1, 8, 9, 10, 11, 13, 14, 15, 16, 18, 19], //通知到分销商的消息类型
      supplierNoticeType: [7, 12, 17], //通知到供应商的消息类型
      informationTypeList: INFORMATIONTYPELIST
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 查询按钮
    search() {
      this.getList();
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.statusBtn(0, null);
      v.getList();
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      if (v.getPermission('ymsStationNotificationTemplate_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsStationNotificationTemplate_query, v.pageParams).then(response => {
          if (response.data.code === 0) {
            v.tableData = response.data.datas || [];
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 选取状态
    statusBtn(index, value) {
      let v = this;
      v.pageParams.status = value;
      v.statusList.forEach((n, i) => {
        n.selected = i === index;
      });
    },
    // 删除消息模板
    deleteMessageTemplateBtn(ymsStationNotificationTemplateId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002269'),
        onOk: () => {
          v.axios.delete(api.delete_ymsStationNotificationTemplate + ymsStationNotificationTemplateId,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000779'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    messageTemplateModal
  }
};
</script>
